import MenuBookIcon from '@mui/icons-material/MenuBook';
import { Box, Pagination, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { productTour } from 'src/constants/productTour';
import {
  reducerUpdateButtonTour,
  reducerUpdateOnTour,
  reducerUpdateTourSteps
} from 'src/features/productTour';
import { useScrolls } from '../Sidebar/ScrollContext';
import ProductTourTooltip from 'src/components/ProductTourTooltip';
import { FirstTimeTour } from 'src/constants/productTour/FirstTimeTour';

const ProductTourButton = React.forwardRef<HTMLDivElement>((props, ref) => {
  const dispatch = useAppDispatch();
  const { isMainOverview } = useAppSelector(
    (state) => state.users.project.flags
  );
  const {
    isTourButtonOpen,
    isOnTour,
    currentTour: { stepNumber, menu }
  } = useAppSelector((state) => state.storeProductTour);
  const [page, setPage] = useState<number>(1);
  const refs = useScrolls();

  const finalProductTour = isMainOverview
    ? productTour
    : productTour.filter((item) => item.menu !== 'overview');

  const isCurrentlyOnTourFirstTimeStep5 =
    isOnTour && stepNumber === 5 && menu === FirstTimeTour.menu;
  const isCurrentlyOnTourFirstTimeStep6 =
    isOnTour && stepNumber === 6 && menu === FirstTimeTour.menu;

  return (
    <>
      <Box
        {...props}
        ref={ref}
        sx={{
          backgroundImage: 'linear-gradient(to right, #2FB5A5, #4C92C6)',
          position: 'fixed',
          zIndex: 999,
          width: '42px',
          height: '42px',
          bottom: '60px',
          right: '20px',
          borderRadius: '100%',
          cursor: isOnTour ? 'default' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={
          !isOnTour
            ? () => dispatch(reducerUpdateButtonTour(!isTourButtonOpen))
            : undefined
        }
        component="div"
      >
        <ProductTourTooltip
          open={isCurrentlyOnTourFirstTimeStep5}
          placement="left-end"
          onClick={() => dispatch(reducerUpdateButtonTour(true))}
        >
          <MenuBookIcon sx={{ color: 'white' }} />
        </ProductTourTooltip>
      </Box>
      {isTourButtonOpen && (
        <ProductTourTooltip
          open={isCurrentlyOnTourFirstTimeStep6}
          placement="top-end"
        >
          <Stack
            sx={{
              position: 'fixed',
              zIndex: 1000,
              width: '300px',
              height: 'fit-content',
              bottom: '60px',
              right: '70px',
              borderRadius: '8px',
              backgroundColor: 'white',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              padding: '16px'
            }}
            spacing={2}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography fontWeight="bold">Product Tour</Typography>
              <Typography
                color="#9D9D9C"
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  dispatch(reducerUpdateButtonTour(false));
                  dispatch(reducerUpdateOnTour(false));
                }}
              >
                x
              </Typography>
            </Stack>
            {finalProductTour
              .slice((page - 1) * 5, page * 5)
              .map((tour, index) => (
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  key={index}
                  sx={{ marginTop: '12px' }}
                >
                  <Box
                    sx={{
                      borderRadius: '100%',
                      width: '14px',
                      height: '14px',
                      borderColor: '#9D9D9C',
                      border: 1
                    }}
                    component="div"
                  />
                  <Typography
                    fontWeight="600"
                    color="#009FE3"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (refs?.sidebar?.[tour.menu]?.current) {
                        refs?.sidebar?.[tour.menu]?.current?.scrollIntoView();
                      }
                      dispatch(reducerUpdateOnTour(true));
                      dispatch(reducerUpdateButtonTour(false));
                      dispatch(
                        reducerUpdateTourSteps({
                          data: {
                            stepNumber: 1,
                            totalStep: tour.steps.length,
                            currentStep: tour.steps[0],
                            steps: tour.steps,
                            menu: tour.menu,
                            submenu: tour.submenu
                          }
                        })
                      );
                    }}
                  >
                    {tour.title}
                  </Typography>
                </Stack>
              ))}
            <Stack alignItems="center">
              <Pagination
                count={Math.ceil((finalProductTour?.length || 0) / 5)}
                onChange={(_, page) => setPage(page)}
                page={page}
                shape="rounded"
                color="primary"
                size="medium"
                siblingCount={0}
              />
            </Stack>
          </Stack>
        </ProductTourTooltip>
      )}
    </>
  );
});

ProductTourButton.displayName = 'ProductTourButton';

export default ProductTourButton;
